import React from 'react';

export const Fabrics = () => (
	<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1107_23246)">
			<path
				d="M25.8252 8.59375L20.8103 21.9322L7.53235 18.356L25.8252 8.59375Z"
				fill="#FDC300"
			/>
			<rect
				width="13.7511"
				height="9.66212"
				transform="matrix(-0.965591 -0.260063 -0.351924 0.936029 20.8105 21.9336)"
				fill="#FDC300"
			/>
		</g>
		<path
			d="M1.07704 25.2494L4.41232 6.52967C4.43563 6.38839 4.48709 6.25312 4.56371 6.13174C4.64032 6.01036 4.74056 5.9053 4.85858 5.8227C4.9766 5.74009 5.11003 5.68158 5.25111 5.65059C5.39218 5.61959 5.53807 5.61673 5.68027 5.64216L13.288 6.9666C13.5754 7.01985 13.8303 7.1827 13.9978 7.42016C14.1654 7.65761 14.2321 7.95071 14.1838 8.23643L10.8348 27.0654C10.6054 28.3332 9.88426 29.4618 8.8256 30.2095C7.76694 30.9572 6.45492 31.2646 5.17033 31.066C2.42769 30.6291 0.594666 27.9666 1.07704 25.2494Z"
			fill="white"
		/>
		<path
			d="M12.3233 18.6681L22.3704 15.0498C22.507 14.9998 22.6523 14.9772 22.7977 14.9831C22.9432 14.9891 23.0861 15.0235 23.2181 15.0844C23.3501 15.1454 23.4686 15.2316 23.5667 15.3381C23.6649 15.4447 23.7408 15.5694 23.79 15.7052L26.4362 22.8872C26.5338 23.1589 26.519 23.4578 26.3951 23.7187C26.2711 23.9796 26.0481 24.1813 25.7746 24.28L9.50945 30.4137"
			fill="#D0DDD8"
		/>
		<path
			d="M26.3397 23.8157V30.0283C26.3397 30.318 26.2235 30.5959 26.0168 30.8007C25.81 31.0056 25.5295 31.1207 25.2371 31.1207H5.94213"
			fill="white"
		/>
		<path
			d="M12.3233 18.6681L22.3704 15.0498C22.507 14.9998 22.6523 14.9772 22.7977 14.9831C22.9432 14.9891 23.0861 15.0235 23.2181 15.0844C23.3501 15.1454 23.4686 15.2316 23.5667 15.3381C23.6649 15.4447 23.7408 15.5694 23.79 15.7052L26.4362 22.8872C26.5338 23.1589 26.519 23.4578 26.3951 23.7187C26.2711 23.9796 26.0481 24.1813 25.7746 24.28L9.50945 30.4137M26.3397 23.8157V30.0283C26.3397 30.318 26.2235 30.5959 26.0168 30.8007C25.81 31.0056 25.5295 31.1207 25.2371 31.1207H5.94213M1.07704 25.2494L4.41232 6.52967C4.43563 6.38839 4.48709 6.25312 4.56371 6.13174C4.64032 6.01036 4.74056 5.9053 4.85858 5.8227C4.9766 5.74009 5.11003 5.68158 5.25111 5.65059C5.39218 5.61959 5.53807 5.61673 5.68027 5.64216L13.288 6.9666C13.5754 7.01985 13.8303 7.1827 13.9978 7.42016C14.1654 7.65761 14.2321 7.95071 14.1838 8.23643L10.8348 27.0654C10.6054 28.3332 9.88426 29.4618 8.8256 30.2095C7.76694 30.9572 6.45492 31.2646 5.17033 31.066C2.42769 30.6291 0.594666 27.9666 1.07704 25.2494Z"
			stroke="#21282B"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.875 25.875C6.49632 25.875 7 25.2034 7 24.375C7 23.5466 6.49632 22.875 5.875 22.875C5.25368 22.875 4.75 23.5466 4.75 24.375C4.75 25.2034 5.25368 25.875 5.875 25.875Z"
			fill="#21282B"
		/>
		<defs>
			<clipPath id="clip0_1107_23246">
				<rect
					width="13.7511"
					height="23.9121"
					fill="white"
					transform="matrix(-0.965591 -0.260063 -0.351924 0.936029 25.8252 8.59375)"
				/>
			</clipPath>
		</defs>
	</svg>
);
